// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f977b662","455":"6b1c96e0","977":"e510c56b"}[chunkId] + ".chunk.js";
};